import type { BiDisplayFormat } from './format';
import { BiAggregation, BiDatasetRef, BiTimeGrain } from './query';
import { BiFieldRole, BiFieldType, BiValueLabels } from './result';

// Mirror of backend `models/src/bi/catalog.ts`.

/**
 * A business key with one meaning and one normalizer across datasets. A
 * field carrying one can be blended with any other field carrying it.
 */
export enum BiConformedKey {
  Date = 'date',
  Store = 'store',
  LicensePlate = 'license_plate',
  Vin = 'vin',
  CustomerPhone = 'customer_phone',
  ServiceItemCategory = 'service_item_category',
  Technician = 'technician',
  ServiceAgent = 'service_agent',
}

export interface BiLocalizedText {
  zh: string;
  en: string;
}

export interface BiCatalogField {
  key: string;
  label: BiLocalizedText;
  role: BiFieldRole;
  type: BiFieldType;
  /** Dimensions on a time field. */
  grains?: BiTimeGrain[];
  /** Measures a spec may re-aggregate; empty for a fixed aggregate. */
  aggs?: BiAggregation[];
  defaultAgg?: BiAggregation;
  /** A measure's default format. */
  format?: BiDisplayFormat;
  conformedKey?: BiConformedKey;
  /** A coded dimension's labels, for the editor's filter pickers. */
  valueLabels?: BiValueLabels;
}

/** What a caller may query on one dataset: only fields their role may use. */
export interface BiDatasetCatalog {
  dataset: BiDatasetRef;
  label: BiLocalizedText;
  description: BiLocalizedText;
  /** The time field a query's time range applies to. */
  primaryTime?: string;
  fields: BiCatalogField[];
}
